import {
	Component, Input, Output, SimpleChanges, EventEmitter
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IpAddress, IpVersion } from 'DiscoveryEngine.TS/Core';
import { MonitorSettings_IpEntry } from 'DiscoveryEngine.TS/Monitors';
import { ComponentBase } from 'common';


@Component({
	selector: 'ping-entry',
	templateUrl: './pingentry.component.html',
	styleUrls: ['./pingentry.component.scss']
})
export class PingEntryComponent extends ComponentBase {

	@Input()
	public visible: boolean;

	@Input()
	public target: MonitorSettings_IpEntry;

	@Input()
	public create: boolean;

	@Input()
	public ipAddresses: IpAddress[];

	@Input()
	public showIpV6: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onSave: EventEmitter<any>

	@Output()
	public onCancel: EventEmitter<any>;

	public settingsForm: UntypedFormGroup;

	public ipAddressOptions: IpAddress[];

	public ipAddress: UntypedFormControl;
	public showIpV6Addresses: UntypedFormControl;
	public hostname: UntypedFormControl;
	public pingHostname: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();

		this.visible = false;
		this.target = null;
		this.create = false;
		this.ipAddresses = [];
		this.visibleChange = new EventEmitter<boolean>();
		this.onSave = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();

		this.buildIpAddressOptions();
	}

	public get hasTarget(): boolean {
		return !!this.target;
	}

	public ngOnInit(): void {
		this.buildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!!changes["target"] || !!changes["ipAddresses"] || !!changes["visible"]) {
			this.showIpV6Addresses = new UntypedFormControl(this.showIpV6);
			this.buildIpAddressOptions();
			this.buildForm();
		}
	}

	public ngOnDestroy(): void {

	}

	public onShowIpV6Changed(): void {
		this.buildIpAddressOptions();
	}

	private buildIpAddressOptions(): void {
		this.ipAddressOptions = [];
		if (!!this.ipAddresses) {
			this.ipAddresses.forEach((ip: IpAddress) => {
				if ((ip.IpVersion == IpVersion.IPv4) ||
					(ip.IpVersion == IpVersion.IPv6 && this.showIpV6Addresses.value)) {

					this.ipAddressOptions.push(ip);
				}
			});
		}
	}

	private buildForm(): void {

		let ipAddress: IpAddress = null;
		let hostname: string = "";
		let pingHostname: boolean = false;

		if (this.hasTarget) {
			ipAddress = this.target.IpAddress;
			hostname = this.target.Hostname;
			pingHostname = this.target.PollByHostname;
		}

		this.ipAddress = new UntypedFormControl(ipAddress);
		this.hostname = new UntypedFormControl(hostname);
		this.pingHostname = new UntypedFormControl(pingHostname);

		this.enableDisableControls();

		this.settingsForm = this.fb.group({
			ipAddress: this.ipAddress,
			showIpV6Addresses: this.showIpV6Addresses,
			hostname: this.hostname,
			pingHostname: this.pingHostname,
		});
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.ipAddress, this.create);
		this.enableDisableFormControl(this.showIpV6Addresses, this.create);
	}

	public get dialogLabel(): string {
		return (this.create ? "Create" : "Edit") + " Ping / IP Monitor";
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);
	}

	public onSaveClicked(): void {
		this.target.IpAddress = this.ipAddress.value;
		this.target.Hostname = this.hostname.value;
		this.target.PollByHostname = this.pingHostname.value;

		this.onSave.emit();
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	public isSaveEnabled(): boolean {
		return !!this.ipAddress.value;
	}

}
